import React from "react";
import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";

import { Icon, InputText } from "@tenant/ui";
import defaultStyles from "./HotelNameFilter.module.scss";

export type HotelNameFilterProps = {
  selectedHotelName: string;
  onChange: (value: string) => void;
  label: string;
  description?: string;
};

export const HotelNameFilter = ({
  selectedHotelName,
  onChange,
  label,
  description,
}: HotelNameFilterProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.HotelNameFilter,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.HotelNameFilter);

  return (
    <div className={block}>
      {description != null && (
        <p className={cn("description")}>{description}</p>
      )}
      <InputText
        label={label}
        className={cn("input-box-wrapper")}
        startContent={<Icon iconName={IconNameEnum.mapPin} />}
        onChange={(e) => onChange(e.target.value)}
        value={selectedHotelName}
        type="text"
      />
    </div>
  );
};
